import { Button, styled } from "@mui/material";
import colors from "../../theme/themeConstants";

export const StyledAddCollectionButton = styled(Button,
  { shouldForwardProp: (props) => props !== "isButtonActive" })<
    { isButtonActive: boolean }>(({ isButtonActive }) => (
      {
        backgroundColor: `${isButtonActive ? colors.redPink : "transparent"}`,
        border: `1px solid ${colors.redPink}`,
        height: "32px",
        minWidth: "32px",
        borderRadius: "25px",
        ":disabled": {
          opacity: 0.3
        },
        ":hover": {
          backgroundColor: colors.redPink
        },
        "& img": {
          height: "auto",
          width: "14px"
        },
        "& svg": {
          height: "auto",
          width: "14px"
        },
      }
    ));
